var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRightWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 44,
    viewBox: "0 0 51 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 22C0 21.1666 0.335788 20.3674 0.933493 19.7781C1.5312 19.1888 2.34186 18.8577 3.18714 18.8577H40.1134L26.4278 5.371C25.8293 4.78096 25.4931 3.9807 25.4931 3.14626C25.4931 2.31182 25.8293 1.51156 26.4278 0.921519C27.0263 0.331481 27.8379 0 28.6843 0C29.5306 0 30.3423 0.331481 30.9408 0.921519L50.0637 19.7753C50.3605 20.0672 50.5959 20.4139 50.7566 20.7957C50.9173 21.1774 51 21.5867 51 22C51 22.4133 50.9173 22.8226 50.7566 23.2043C50.5959 23.5861 50.3605 23.9329 50.0637 24.2247L30.9408 43.0785C30.3423 43.6685 29.5306 44 28.6843 44C27.8379 44 27.0263 43.6685 26.4278 43.0785C25.8293 42.4884 25.4931 41.6882 25.4931 40.8537C25.4931 40.0193 25.8293 39.219 26.4278 38.629L40.1134 25.1423H3.18714C2.34186 25.1423 1.5312 24.8112 0.933493 24.2219C0.335788 23.6326 0 22.8334 0 22Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightWhite);
export default __webpack_public_path__ + "static/media/arrow-right-white.8fab736b08d595933dc524815331ee09.svg";
export { ForwardRef as ReactComponent };